<template>
  <div class="intro">
    <div class="soluRightBtn">
      <span style="color: #808080">当前位置：</span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/association' }"
          >水泵协会</el-breadcrumb-item
        >
        <el-breadcrumb-item>协会介绍</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="introduction">
      <div class="introduction_left">
        <h3>协会介绍</h3>
        <div
          @click="onClickMenu(index)"
          class="introduction_title"
          :class="menuIndex == index ? 'introduction_title_active' : ''"
          v-for="(item, index) in introductionList"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- <div v-html=""></div> -->
      <div class="introductionBox vHtmlMess" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import { associationProgram } from "../../utils/associationApi"

export default {
  name: "introduction",
  metaInfo: {
    title: "宁夏工业企业数字化转型公共服务平台--水泵协会介绍", // set a title
    // meta: [
    //   {
    //     // set meta
    //     name: "keywords",
    //     content:
    //       "水泵打印|水泵制造|水泵打印行业资讯|水泵打印新闻|水泵打印政策|水泵打印行业数据|水泵打印技术|宁夏工业企业数字化转型公共服务平台|水泵制造行业政策|树脂水泵打印|金属水泵打印|生物水泵打印|智能制造",
    //   },
    //   {
    //     // set meta
    //     name: "description",
    //     content:
    //       "宁夏工业企业数字化转型公共服务平台，每日精选水泵打印业内重点新闻，及时传递价值讯息。宁夏工业企业数字化转型公共服务平台是安徽宁夏工业企业数字化转型公共服务平台数字科技有限公司打造的水泵制造领域综合性工业互联网平台。聚合水泵打印产业链六大资源，水泵模型资源、设计师资源、生产制造资源、产品资源、课程资源、软件资源。并提供四大解决方案：智能制造标准体系的智能工厂解决方案、基于标识解析体系的远程运维解决方案、基于C2M模式的水泵打印个性化定制解决方案、水泵制造行业企业数字化解决方案。",
    //   },
    // ],
  },
  components: {},
  data() {
    return {
      menuIndex: 0,
      introductionList: [],
      content: "",
    }
  },
  created() {
    this.programList()
  },
  methods: {
    programList() {
      associationProgram({ type: "ITEM" }).then((resp) => {
        this.introductionList = resp
        if (resp.length > 0) {
          this.content = resp[0].content
        }
      })
    },
    onClickMenu(index) {
      this.menuIndex = index
      this.content = this.introductionList[index].content
    },
  },
}
</script>

<style scoped lang="less">
.intro {
  background-color: #efefef;
  padding-bottom: 20px;
}
.soluRightBtn {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  font-size: 14px;
  color: #6e6e6e;
  display: flex;
  align-items: center;
  font-weight: 400;
}
.introduction {
  width: 1200px;
  display: flex;
  margin: 0 auto;
  min-height: 448px;
  .introduction_left {
    flex-shrink: 0;
    width: 200px;
    background-color: #fff;
    h3 {
      background-color: #2d50a1;
      padding: 8px 0;
      text-align: center;
      color: #fff;
    }
    .introduction_title {
      padding: 10px 0;
      text-align: center;
      margin: 3px;
      font-size: 15px;
      cursor: pointer;
      &:hover {
        background-color: rgba(0, 153, 153, 0.223);
      }
    }
    .introduction_title_active {
      background-color: rgba(0, 153, 153, 0.223);
    }
  }
  .introductionBox {
    background-color: #fff;
    margin-left: 10px;
    width: 100%;
    padding: 0 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/association/introduction.vue